//# sourceMappingURL=transform.mjs.map
/// <reference types="./transform.d.mts" />
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $float from "../../../gleam_stdlib/gleam/float.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";
import * as $angle from "../../sketch/css/angle.mjs";
import * as $length from "../../sketch/css/length.mjs";

class Matrix extends $CustomType {
  constructor($0, $1, $2, $3, $4, $5) {
    super();
    this[0] = $0;
    this[1] = $1;
    this[2] = $2;
    this[3] = $3;
    this[4] = $4;
    this[5] = $5;
  }
}

class Matrix3D extends $CustomType {
  constructor($0, $1, $2, $3, $4, $5, $6, $7, $8, $9, $10, $11, $12, $13, $14, $15) {
    super();
    this[0] = $0;
    this[1] = $1;
    this[2] = $2;
    this[3] = $3;
    this[4] = $4;
    this[5] = $5;
    this[6] = $6;
    this[7] = $7;
    this[8] = $8;
    this[9] = $9;
    this[10] = $10;
    this[11] = $11;
    this[12] = $12;
    this[13] = $13;
    this[14] = $14;
    this[15] = $15;
  }
}

class Translate extends $CustomType {
  constructor($0, $1) {
    super();
    this[0] = $0;
    this[1] = $1;
  }
}

class Translate3D extends $CustomType {
  constructor($0, $1, $2) {
    super();
    this[0] = $0;
    this[1] = $1;
    this[2] = $2;
  }
}

class TranslateX extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class TranslateY extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class TranslateZ extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Scale extends $CustomType {
  constructor($0, $1) {
    super();
    this[0] = $0;
    this[1] = $1;
  }
}

class Scale3D extends $CustomType {
  constructor($0, $1, $2) {
    super();
    this[0] = $0;
    this[1] = $1;
    this[2] = $2;
  }
}

class ScaleX extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class ScaleY extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class ScaleZ extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Rotate extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Rotate3D extends $CustomType {
  constructor($0, $1, $2, $3) {
    super();
    this[0] = $0;
    this[1] = $1;
    this[2] = $2;
    this[3] = $3;
  }
}

class RotateX extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class RotateY extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class RotateZ extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Skew extends $CustomType {
  constructor($0, $1) {
    super();
    this[0] = $0;
    this[1] = $1;
  }
}

class SkewX extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class SkewY extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Perspective extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

/**
 * The `matrix()` CSS function defines a homogeneous 2D transformation matrix.
 *
 * > ```gleam
 * > transform.matrix(a, b, c, d, tx, ty)
 * > ```
 * > is a shorthand for
 * > ```gleam
 * > transform.matrix_3d(#(
 * >    #(a,  b,  0,  0),
 * >    #(c,  d,  0,  0),
 * >    #(0,  0,  1,  0),
 * >    #(tx, ty, 0,  1)
 * > ))
 * > ```
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/matrix)
 */
export function matrix(a, b, c, d, tx, ty) {
  return new Matrix(a, b, c, d, tx, ty);
}

/**
 * The `matrix3d()` CSS function defines a 3D transformation as a 4x4
 * homogeneous matrix.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/matrix3d)
 */
export function matrix_3d(values) {
  let a1;
  let b1;
  let c1;
  let d1;
  let a2;
  let b2;
  let c2;
  let d2;
  let a3;
  let b3;
  let c3;
  let d3;
  let a4;
  let b4;
  let c4;
  let d4;
  a1 = values[0][0];
  b1 = values[0][1];
  c1 = values[0][2];
  d1 = values[0][3];
  a2 = values[1][0];
  b2 = values[1][1];
  c2 = values[1][2];
  d2 = values[1][3];
  a3 = values[2][0];
  b3 = values[2][1];
  c3 = values[2][2];
  d3 = values[2][3];
  a4 = values[3][0];
  b4 = values[3][1];
  c4 = values[3][2];
  d4 = values[3][3];
  return new Matrix3D(
    a1,
    b1,
    c1,
    d1,
    a2,
    b2,
    c2,
    d2,
    a3,
    b3,
    c3,
    d3,
    a4,
    b4,
    c4,
    d4,
  );
}

/**
 * The `translate()` CSS function repositions an element in the horizontal
 * and/or vertical directions.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/translate)
 */
export function translate(x, y) {
  return new Translate(x, y);
}

/**
 * The `translate3d()` CSS function repositions an element in 3D space.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/translate3d)
 */
export function translate_3d(x, y, z) {
  return new Translate3D(x, y, z);
}

/**
 * The `translateX()` CSS function repositions an element horizontally on the
 * 2D plane.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/translateX)
 */
export function translate_x(x) {
  return new TranslateX(x);
}

/**
 * The `translateY()` CSS function repositions an element vertically on the
 * 2D plane.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/translateY)
 */
export function translate_y(y) {
  return new TranslateY(y);
}

/**
 * The `translateZ()` CSS function repositions an element along the z-axis in
 * 3D space, i.e., closer to or farther away from the viewer.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/translateZ)
 */
export function translate_z(y) {
  return new TranslateZ(y);
}

/**
 * The `scale()` CSS function defines a transformation that resizes an element
 * on the 2D plane. Because the amount of scaling is defined by a vector [sx, sy],
 * it can resize the horizontal and vertical dimensions at different scales.
 *
 * > The `scale()` function only scales in 2D. To scale in 3D, use `scale3d()` instead.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/scale)
 */
export function scale(x, y) {
  return new Scale(x, y);
}

/**
 * The `scale3d()` CSS function defines a transformation that resizes an element
 * in 3D space. Because the amount of scaling is defined by a vector [sx, sy, sz],
 * it can resize different dimensions at different scales.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/scale3d)
 */
export function scale_3d(x, y, z) {
  return new Scale3D(x, y, z);
}

/**
 * The `scaleX()` CSS function defines a transformation that resizes an element
 * along the x-axis (horizontally).
 *
 * > `scaleX(sx)` is equivalent to `scale(sx, 1)` or `scale3d(sx, 1, 1)`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/scaleX)
 */
export function scale_x(x) {
  return new ScaleX(x);
}

/**
 * The `scaleY()` CSS function defines a transformation that resizes an element
 * along the y-axis (vertically).
 *
 * > `scaleY(sy)` is equivalent to `scale(1, sy)` or `scale3d(1, sy, 1)`.
 * >
 * > `transform: rotateX(180deg)`; === `transform: scaleY(-1);`
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/scaleY)
 */
export function scale_y(y) {
  return new ScaleY(y);
}

/**
 * The `scaleZ()` CSS function defines a transformation that resizes an element
 * along the z-axis.
 *
 * > `scaleZ(sy)` is equivalent to `scale3d(1, 1, sy)`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/scaleZ)
 */
export function scale_z(y) {
  return new ScaleZ(y);
}

/**
 * The `rotate()` CSS function defines a transformation that rotates an element
 * around a fixed point on the 2D plane, without deforming it.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/rotate)
 */
export function rotate(value) {
  return new Rotate(value);
}

/**
 * The `rotate3d()` CSS function defines a transformation that rotates an element
 * around a fixed axis in 3D space, without deforming it
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/rotate3d)
 */
export function rotate_3d(x, y, z, value) {
  return new Rotate3D(x, y, z, value);
}

/**
 * The `rotateX()` CSS function defines a transformation that rotates an element
 * oarend the x-axis (horizontal) without deforming it.
 *
 * > `rotateX(a)` is equivalent to `rotate3d(1, 0, 0, a)`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/rotateX)
 */
export function rotate_x(x) {
  return new RotateX(x);
}

/**
 * The `rotateY()` CSS function defines a transformation that rotates an element
 * oarend the y-axis (vertical) without deforming it.
 *
 * > `rotateY(a)` is equivalent to `rotate3d(0, 1, 0, a)`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/rotateY)
 */
export function rotate_y(y) {
  return new RotateY(y);
}

/**
 * The `rotateZ()` CSS function defines a transformation that rotates an element
 * oarend the z-axis without deforming it.
 *
 * > `rotateZ(a)` is equivalent to `rotate3d(0, 0, 1, a)`.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/rotateZ)
 */
export function rotate_z(y) {
  return new RotateZ(y);
}

/**
 * The `skew()` CSS function defines a transformation that skews an element on
 * the 2D plane.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/skew)
 */
export function skew(x, y) {
  return new Skew(x, y);
}

/**
 * The `skewX()` CSS function defines a transformation that skews an element
 * in the horizontal direction on the 2D plane.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/skewX)
 */
export function skew_x(x) {
  return new SkewX(x);
}

/**
 * The `skewY()` CSS function defines a transformation that skews an element
 * in the vertical direction on the 2D plane.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/skewY)
 */
export function skew_y(x) {
  return new SkewY(x);
}

/**
 * The `perspective()` CSS function defines a transformation that sets the
 * distance between the user and the z=0 plane, the perspective from which the
 * viewer would be if the 2-dimensional interface were 3-dimensional.
 *
 * ---
 *
 * [MDN Reference](https://developer.mozilla.org/docs/Web/CSS/transform-function/perspective)
 */
export function perspective(x) {
  return new Perspective(x);
}

function transform_to_string(value) {
  if (value instanceof Matrix) {
    let a = value[0];
    let b = value[1];
    let c = value[2];
    let d = value[3];
    let tx = value[4];
    let ty = value[5];
    let _pipe = toList([a, b, c, d, tx, ty]);
    let _pipe$1 = $list.map(_pipe, $float.to_string);
    let _pipe$2 = $string.join(_pipe$1, ", ");
    return ((matrix) => { return ("matrix(" + matrix) + ")"; })(_pipe$2);
  } else if (value instanceof Matrix3D) {
    let a = value[0];
    let b = value[1];
    let c = value[2];
    let d = value[3];
    let e = value[4];
    let f = value[5];
    let g = value[6];
    let h = value[7];
    let i = value[8];
    let j = value[9];
    let k = value[10];
    let l = value[11];
    let m = value[12];
    let n = value[13];
    let o = value[14];
    let p = value[15];
    let _pipe = toList([a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p]);
    let _pipe$1 = $list.map(_pipe, $float.to_string);
    let _pipe$2 = $string.join(_pipe$1, ", ");
    return ((matrix) => { return ("matrix3d(" + matrix) + ")"; })(_pipe$2);
  } else if (value instanceof Translate) {
    let x = value[0];
    let y = value[1];
    let x$1 = $length.to_string(x);
    let y$1 = $length.to_string(y);
    return ("translate(" + $string.join(toList([x$1, y$1]), ", ")) + ")";
  } else if (value instanceof Translate3D) {
    let x = value[0];
    let y = value[1];
    let z = value[2];
    let x$1 = $length.to_string(x);
    let y$1 = $length.to_string(y);
    let z$1 = $length.to_string(z);
    return ("translate3d(" + $string.join(toList([x$1, y$1, z$1]), ", ")) + ")";
  } else if (value instanceof TranslateX) {
    let x = value[0];
    return ("translateX(" + $length.to_string(x)) + ")";
  } else if (value instanceof TranslateY) {
    let y = value[0];
    return ("translateY(" + $length.to_string(y)) + ")";
  } else if (value instanceof TranslateZ) {
    let z = value[0];
    return ("translateZ(" + $length.to_string(z)) + ")";
  } else if (value instanceof Scale) {
    let x = value[0];
    let y = value[1];
    let x$1 = $float.to_string(x);
    let y$1 = $float.to_string(y);
    return ("scale(" + $string.join(toList([x$1, y$1]), ", ")) + ")";
  } else if (value instanceof Scale3D) {
    let x = value[0];
    let y = value[1];
    let z = value[2];
    let x$1 = $float.to_string(x);
    let y$1 = $float.to_string(y);
    let z$1 = $float.to_string(z);
    return ("scale3d(" + $string.join(toList([x$1, y$1, z$1]), ", ")) + ")";
  } else if (value instanceof ScaleX) {
    let x = value[0];
    return ("scaleX(" + $float.to_string(x)) + ")";
  } else if (value instanceof ScaleY) {
    let y = value[0];
    return ("scaleY(" + $float.to_string(y)) + ")";
  } else if (value instanceof ScaleZ) {
    let z = value[0];
    return ("scaleZ(" + $float.to_string(z)) + ")";
  } else if (value instanceof Rotate) {
    let ang = value[0];
    return ("rotate(" + $angle.to_string(ang)) + ")";
  } else if (value instanceof Rotate3D) {
    let x = value[0];
    let y = value[1];
    let z = value[2];
    let ang = value[3];
    let x$1 = $float.to_string(x);
    let y$1 = $float.to_string(y);
    let z$1 = $float.to_string(z);
    let angle = $angle.to_string(ang);
    return ("rotate3d(" + $string.join(toList([x$1, y$1, z$1, angle]), ", ")) + ")";
  } else if (value instanceof RotateX) {
    let x = value[0];
    return ("rotateX(" + $angle.to_string(x)) + ")";
  } else if (value instanceof RotateY) {
    let y = value[0];
    return ("rotateY(" + $angle.to_string(y)) + ")";
  } else if (value instanceof RotateZ) {
    let z = value[0];
    return ("rotateZ(" + $angle.to_string(z)) + ")";
  } else if (value instanceof Skew) {
    let x = value[0];
    let y = value[1];
    let x$1 = $angle.to_string(x);
    let y$1 = $angle.to_string(y);
    return ("skew(" + $string.join(toList([x$1, y$1]), ", ")) + ")";
  } else if (value instanceof SkewX) {
    let x = value[0];
    return ("skewX(" + $angle.to_string(x)) + ")";
  } else if (value instanceof SkewY) {
    let y = value[0];
    return ("skewY(" + $angle.to_string(y)) + ")";
  } else {
    let x = value[0];
    return ("perspective(" + $length.to_string(x)) + ")";
  }
}

/**
 * Internal function, can be used if you need to go from a transform function
 * to a String in case you're building on top of sketch.
 * 
 * @ignore
 */
export function to_string(value) {
  return $bool.guard(
    $list.is_empty(value),
    "none",
    () => {
      let _pipe = $list.map(value, transform_to_string);
      return $string.join(_pipe, " ");
    },
  );
}
